import React, { useEffect, useState } from 'react'
import {
    Tooltip,
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Dialog,
    DialogContent,
    Chip,
    Button,
} from '@mui/material'
import { Formik } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SupplierDialog from '../Components/SupplierDialog';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import CreateIcon from '@mui/icons-material/Create';
import { toast, useToastContainer } from 'react-toastify';
import SearchIcon from '@mui/icons-material/Search';
import GrnDialog from '../Components/GrnDialog';
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import BeatLoader from "react-spinners/BeatLoader";



function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function Grn() {
    const [pageTitle, setPageTitle] = useState('Grn Management');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [itemList, setItemList] = useState([]);
    const [itemSearch, setItemSearch] = useState("");
    const [listImageView, setListImageView] = useState();
    const [imageDialog, setImageDialog] = useState(false);
    const [updateID, setUpdateID] = useState(0);
    const [loading, setLoading] = useState(true)

    // //console.log(itemList)
    useEffect(() => {
        GetAllItemDetailForGrid();
    }, [])

    useEffect(() => {
        if (updateID === 0 && dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [updateID])

    useEffect(() => {
        if (dialogOpen === false) {
            GetAllItemDetailForGrid();
        }
    }, [dialogOpen])

    function handleClick() {
        setDialogOpen(true);
    }

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - itemList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    function GetAllItemDetailForGrid() {
        axios.get('https://serverrion.mylksystems.store/grn/GetAllGrns').then((res) => {
            if (res.data.length > 0) {
                setItemList(res.data);
                setLoading(false)
            } else {
                setItemList([]);
                toast.error("No records to display!");
            }
        })
    }

    function UpdateRowData(rowID) {
        setUpdateID(rowID);
        setDialogOpen(true);
    }



    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={11} xs={11}>
                    {titleName}
                </Grid>
                <Grid item md={1} xs={1}>
                    <Box display='flex' justifyContent='flex-end' alignItems='center' >
                        <Tooltip title="Add GRN">
                            <IconButton>
                                <AddCircleOutlineIcon onClick={() => handleClick()} sx={{ color: 'black' }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Grid>
            </Grid>
        )
    }

    const toEdit = async (row) => {
        // Show confirmation alert before deletion
        const isConfirmed = window.confirm(
            "Are you sure you want to delete this GRN? This action will also reduce the Inventory quantity of the particular GRN."
        );
    
        if (isConfirmed) {
            // If the user confirmed, proceed with deletion
            // console.log(row);
    
            const data = {
                grnKey: row.grnKey
            };
    
            setDeleteLoading(true);
    
            try {
                const response = await axios.post("https://serverrion.mylksystems.store/grn/DeleteGrn", data);
                if (response.data) {
                    toast.success("GRN Deleted Successfully!");
                    GetAllItemDetailForGrid();  // Reload the grid data after deletion
                } else {
                    toast.error("Something went wrong!");
                }
            } catch (error) {
                console.error(error);
                toast.error("Failed to delete GRN!");
            } finally {
                setDeleteLoading(false);
            }
        } else {
            // If the user canceled, do nothing
            console.log("Deletion canceled");
        }
    };
    

    const [deleteLoading,setDeleteLoading] = useState(false)

    return (
        <>
            <Container maxWidth={false} sx={{ paddingTop: '15vh' }}>
                <Formik
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form >
                            <Card sx={{ padding: '15px' }}>
                                <CardHeader
                                    title={cardTitle(pageTitle)}
                                />
                                <Divider />
                                <br />
                                <TableContainer>
                                    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        Search by Item / GRN ID  :
                                        <TextField
                                            id="input-with-sx"
                                            variant="standard"
                                            value={itemSearch}
                                            onChange={(e) => { setItemSearch(e.target.value) }}
                                            color='success'
                                        />
                                        <SearchIcon sx={{ color: 'action.active', mr: 1, my: 1 }} />
                                    </Box>
                                    <br />
                                    <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align='left' sx={{ fontWeight: 'bold' }}>GRN ID</TableCell>
                                                <TableCell align='left' sx={{ fontWeight: 'bold' }}>Item</TableCell>
                                                <TableCell align='left' sx={{ fontWeight: 'bold' }}>Supplier</TableCell>
                                                <TableCell align='left' sx={{ fontWeight: 'bold' }}>Total (LKR)</TableCell>
                                                <TableCell align='left' sx={{ fontWeight: 'bold' }}>Pending (LKR)</TableCell>
                                                <TableCell align='left' sx={{ fontWeight: 'bold' }}>Qty</TableCell>
                                                <TableCell align='left' sx={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loading ? <>
                                                <TableCell align='left' colSpan={6}>

                                                    <div style={{ display: 'flex', justifyContent: 'center' }}><BeatLoader color='#000000' /></div>
                                                </TableCell>
                                            </> : <>

                                                {(rowsPerPage > 0
                                                    ? itemList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : itemList
                                                ).filter((element) => {
                                                    if (itemSearch === "") {
                                                        return element;
                                                    } else if ((element.grnKey.toString().includes(itemSearch))) {
                                                        return element;
                                                    } else if ((element.itemName.toLowerCase()).includes(itemSearch.toLowerCase())) {
                                                        return element;
                                                    }
                                                }).map((row) => (
                                                    <TableRow key={row._id}>
                                                        <TableCell align='left'>{row.grnKey}</TableCell>
                                                        <TableCell align='left'>{row.itemName}</TableCell>
                                                        <TableCell align='left'>{row.supplierName}</TableCell>
                                                        <TableCell align='left'>{row.totalAmount}</TableCell>
                                                        <TableCell align='left'>{row.totalAmount - row.paidAmount}.00</TableCell>
                                                        <TableCell align='left'>{row.qty}</TableCell>
                                                        <TableCell align='left'>
                                                            
                                                            <Button variant = 'contained' onClick={() => {toEdit(row)}}>
                                                                {deleteLoading?<>
                                                                    <BeatLoader color='#000000' size={10} />
                                                                </>:<>Delete</>}</Button>
                                                            </TableCell>

                                                    </TableRow>
                                                ))}
                                                {emptyRows > 0 && (
                                                    <TableRow style={{ height: 53 * emptyRows }}>
                                                        <TableCell colSpan={7} />
                                                    </TableRow>
                                                )}
                                            </>}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 25, 35, { label: 'All', value: -1 }]}
                                                    colSpan={7}
                                                    count={itemList.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    slotProps={{
                                                        select: {
                                                            inputProps: {
                                                                'aria-label': 'rows per page',
                                                            },
                                                            native: true,
                                                        },
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>



                            </Card>
                        </form>
                    )}

                </Formik>
            </Container>

            

            {/* item manegemnet dialog box */}
            <GrnDialog
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                updateID={updateID}
                setUpdateID={setUpdateID}
            />
        </>
    )
}

export default Grn